import { TableColumnMeta } from "ds/components/Table/types";

export const MAX_CELL_WIDTH = 2000;

export enum ActionsColumnId {
  ACTIONS = "actions",
}

export const ACTIONS_COLUMN_CONFIG: TableColumnMeta = {
  id: ActionsColumnId.ACTIONS,
  title: "Environment actions",
  noHeader: true,
  defaultWidth: 60,
  minWidth: 60,
  maxWidth: 60,
  allowsSorting: false,
  resizable: false,
  canHide: false,
  configurable: false,
  canPin: false,
  canMove: false,
};
